const Legenda = () => {

    return ( 
        <div className="legenda">
            <p id="pedido" style={{maxWidth: '400px', paddingTop: '30px',  marginLeft: '10px'}}></p>
            <p id="verdescuro" className="legenda" style={{color:'#FFFFFF', backgroundColor:'#008000'}}></p>
            <p id="verdeclaro" className="legenda" style={{color:'#000000', backgroundColor:'#00FF00'}}></p>
            <p id="amarelo" className="legenda" style={{color:'#000000', backgroundColor:'#FFDF00'}}></p>
            <p id="laranja" className="legenda" style={{color:'#FFFFFF', backgroundColor:'#FF8C00'}}></p>
            <p id="vermelho" className="legenda" style={{color:'#FFFFFF', backgroundColor:'#FF0000'}}></p>
        </div>
    );
}

export default Legenda;